import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import AgentLogin from "@/pages/AgentLogin";
import AgentDashboard from "@/pages/AgentDashboard";
import QuickAnalyze from "@/pages/QuickAnalyze";
import AutoRules from "@/pages/AutoRules";
import MerchantLogin from "@/pages/MerchantLogin";
import MerchantDashboard from "@/pages/MerchantDashboard";
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/funding/:slug" element={<ProductPage />} />
            <Route path="/agent/login" element={<AgentLogin />} />
            <Route path="/agent/dashboard" element={<AgentDashboard />} />
            <Route path="/agent/analyze" element={<QuickAnalyze />} />
            <Route path="/agent/rules" element={<AutoRules />} />
            <Route path="/merchant/login" element={<MerchantLogin />} />
            <Route path="/merchant/dashboard" element={<MerchantDashboard />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
